import classNames from "classnames";
import { PatternFormat } from "react-number-format";

export const PatternFormatInput = ({
  field,
  format,
  mask,
  className,
  props,
}) => {
  return (
    <PatternFormat
      format={format}
      allowEmptyFormatting={false}
      placeholder="Telefon Numarasını Giriniz"
      mask={mask}
      className={classNames({
        "bg-white w-full rounded-2xl outline-none font-light text-xl px-5": true,
        [className]: className,
      })}
      {...field}
      {...props}
    />
  );
};
